/**
 * Utility function to generate consistent avatar colors based on client ID
 * This replaces the backend avatarColor field with frontend calculation
 *
 * Keep in sync with mobile/src/utils/avatarColor.ts — palette and hash algorithm
 * must match so the same client renders the same color across CORE and mobile.
 * Mobile is an isolated Expo workspace that doesn't import from @hapana/shared.
 */

const AVATAR_COLORS = [
  '#FF6B6B', // Red
  '#4ECDC4', // Teal
  '#45B7D1', // Blue
  '#96CEB4', // Green
  '#FECA57', // Yellow
  '#FF9FF3', // Pink
]

/**
 * Generate a consistent avatar color based on client ID
 * @param {string|number} clientId - The client ID to generate color from
 * @returns {string} Hex color code
 */
export const getAvatarColor = (clientId) => {
  if (!clientId && clientId !== 0) {
    return AVATAR_COLORS[0]
  } // Default to first color if no ID

  // Convert to string if it's a number
  const idString = String(clientId)

  // Generate hash from client ID (same algorithm as backend was using)
  const hash = idString.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)

  // Return color based on hash
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

export default getAvatarColor
